module.exports = __webpack_public_path__ + "img/msc.33e9a33a.svg";